import { useEffect, useState } from 'react';
import { Keyboard } from '@capacitor/keyboard';
import { isCapacitor } from '../utils/platform';

// Profile field names that should trigger keyboard lift
const PROFILE_FIELDS = ['firstName', 'lastName', 'title', 'specialty'];

export const useKeyboardAware = (enabled = true) => {
  const [keyboardHeight, setKeyboardHeight] = useState(0);
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);
  const [focusedField, setFocusedField] = useState(null);

  useEffect(() => {
    if (!isCapacitor || !enabled) return;

    const showListener = Keyboard.addListener('keyboardWillShow', (info) => {
      const activeEl = document.activeElement;
      const fieldName = activeEl?.name || activeEl?.id || '';

      setKeyboardHeight(info.keyboardHeight);
      setIsKeyboardVisible(true);
      setFocusedField(fieldName);

      // Scroll focused input into view after transform
      setTimeout(() => {
        document.activeElement?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 100);
    });

    const hideListener = Keyboard.addListener('keyboardDidHide', () => {
      setKeyboardHeight(0);
      setIsKeyboardVisible(false);
      setFocusedField(null);
    });

    return () => {
      showListener.then(l => l.remove());
      hideListener.then(l => l.remove());
    };
  }, [enabled]);

  // Only lift for profile fields (title, prénom, nom, specialty)
  const isProfileFieldFocused = PROFILE_FIELDS.includes(focusedField);

  return {
    keyboardHeight,
    isKeyboardVisible,
    isProfileFieldFocused,
    shouldLift: isKeyboardVisible && isProfileFieldFocused
  };
};
